import type { CSSProperties, ReactNode } from 'react'
import { cn } from 'cn'

export interface LoaderProps {
  small?: boolean
  type?: 'dark' | 'light'
  className?: string
  style?: CSSProperties
  iconClassName?: string
}

export const AudioLoaderFile = ({
  small = false,
  type = 'light',
  className,
  style,
  iconClassName,
}: LoaderProps): ReactNode => (
  <div role="status" className={className} style={style}>
    <svg
      aria-hidden="true"
      className={cn(
        small ? 'size-5' : 'size-8',
        type === 'light' ? 'fill-icon-accent text-icon-on' : 'fill-bg-primary text-text-primary',
        iconClassName,
      )}
      viewBox="0 0 86 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="86"
        height="10"
        rx="5"
        fill="var(--color-bg-tertiary)"
        className="text-text-primary"
      />
      <rect
        x="0"
        y="1"
        height="8"
        rx="4"
        fill="var(--color-icon-accent)"
        className="animate-fillBar text-icon-accent"
      />
    </svg>
    <span className="text-xs text-text-secondary">Uploading...</span>
  </div>
)
